<template>
  <CommonLoginV2 platform="client" />
</template>

<script>
import CommonLoginV2 from '@/views/common/loginV2.optimized.vue';

export default {
  name: 'ClientLoginV2', 
  components: {
    CommonLoginV2
  }
};
</script>